import '@hapana/shared/utils/type-defs.util'

/** @type {Styles} */
export const styles = {
  form: {
    display: 'contents',
  },
  dialogContent: {
    display: 'flex',
    flexDirection: 'column',
    gap: 2,
    paddingX: 0,
    paddingBottom: 4,
  },
  formFields: {
    display: 'flex',
    flexDirection: 'column',
    gap: 2,
  },
  statusContainer: {
    display: 'flex',
    flexDirection: 'column',
    gap: 1,
  },
  infoPanel: {
    paddingY: 1.25,
    paddingLeft: 2.25,
    paddingRight: 1.5,
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between',
    borderRadius: 2,
  },
  infoPanelTime: {
    backgroundColor: 'blue.lightest',
  },
  infoPanelInfo: {
    backgroundColor: 'gray.3',
  },
  infoPanelContent: {
    display: 'flex',
    alignItems: 'center',
    gap: 1.25,
  },
  infoPanelIcon: {
    alignSelf: 'flex-start',
    fontSize: '1rem',
  },
  infoPanelIconTime: {
    color: 'blue.dark',
  },
  infoPanelIconInfo: {
    color: 'gray.64',
  },
  infoPanelDataContainer: {
    display: 'flex',
    flexDirection: 'column',
  },
  infoPanelDataRow: {
    display: 'flex',
    gap: 0.5,
    alignItems: 'center',
  },
  modalGroupTitleStyles: {
    width: 'unset',
    paddingRight: 2,
    backgroundColor: 'gray.3',
  },
  fieldRow: {
    display: 'grid',
    gridTemplateColumns: '1fr 1fr',
    gap: 2,
  },
  imageSection: {
    display: 'flex',
    flexDirection: 'column',
    gap: 1,
  },
  imageContainer: {
    display: 'flex',
    gap: 2,
    alignItems: 'center',
  },
  imageInfo: {
    display: 'flex',
    flexDirection: 'column',
    gap: 0.5,
  },
  avatar: {
    width: 64,
    height: 64,
    borderRadius: '50%',
  },
  updateImageButton: {
    padding: 0,
  },
  categorySection: {
    display: 'flex',
    flexDirection: 'column',
    gap: 1.5,
  },
  categoryRadioGroup: {
    display: 'grid',
    gridTemplateColumns: '1fr 1fr 1fr',
  },
  timerFields: {
    display: 'flex',
    flexDirection: 'column',
    gap: 2,
    paddingLeft: 3,
    borderLeft: '2px solid',
    borderColor: 'primary.main',
  },
  divider: {
    my: 1,
  },
}
